import {
  FETCH_NOTIFICATIONS_LOADING,
  FETCH_NOTIFICATIONS_SUCCESS,
  MARK_READ,
  MARK_ALL_READ
} from '../../Action/NotificationAction/NotificationAction';

const initialState = {
  notifications: [],
  unread_count: 0,
  loading: false
};

const NotificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_NOTIFICATIONS_LOADING:
      return { ...state, loading: true };

    case FETCH_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        notifications: action.payload.notifications || [],
        unread_count: action.payload.unread_count || 0
      };

    case MARK_READ:
      return {
        ...state,
        notifications: state.notifications.map((n) => (n.id === action.payload ? { ...n, is_read: 1 } : n)),
        unread_count: Math.max(0, state.unread_count - 1)
      };

    case MARK_ALL_READ:
      return {
        ...state,
        notifications: state.notifications.map((n) => ({ ...n, is_read: 1 })),
        unread_count: 0
      };

    default:
      return state;
  }
};

export default NotificationReducer;
